export default __webpack_public_path__ + "/assets/h1.png";